<div *transloco="let t" class="flex flex-col gap-10 p-10">
  <div class="text-xl font-thin">
    {{ t('subscription.title') }}
  </div>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
    @for (plan of plans.value(); track plan.id) {
      <div class="bg-wundart-gray-100 p-4 flex flex-col justify-between gap-5 cursor-pointer"
           [class.!cursor-not-allowed]="hasSubscription()" (click)="setCurrentPlan(plan)">
        <div class="flex flex-col gap-4">
          <div class="flex justify-between items-center">
            <div class="text-xl">{{ t('plans.' + plan.productId + '.' + plan.planName + '.label') }}</div>
            <wun-checkbox [value]="plan.planId"
                          [disabled]="hasSubscription()"
                          [(ngModel)]="currentPlan" label=""/>
          </div>
          <div>
            <div class="font-thin">{{ t('plans.' + plan.productId + '.' + plan.planName + '.description') }}</div>
          </div>
        </div>
        <div>
          {{ plan.price | currency : 'EUR' : '' : '1.2-2' }} €
        </div>
      </div>
    }
  </div>

  @if (currentPlan() && !hasSubscription()) {
    <div class="w-full flex justify-center">
      <wun-paypal-button [kind]="'SUBSCRIPTION'" [planId]="currentPlan()" (completed)="reloadMe()"/>
    </div>
  }
  @let sub = subscription();
  <div class="text-xl">
    @if (hasSubscription() && sub) {
      @if (sub.kind === 'LIFETIME') {
        {{t('subscription.lifetime')}}
      } @else {
        {{t('subscription.alreadyActive')}}
      }
    }
  </div>

</div>


